/* STREETIWFY header — header.js (Shopify OS 2.0). Vanilla JS, no dependencies. */
(() => {
    'use strict';
    if (window.SwHeaderLoaded) return;
    window.SwHeaderLoaded = true;
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
    const html = document.documentElement;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 1024px)');

    /* Money formatting with the shop's own format (e.g. "₹{{amount}}") */
    const formatMoney = (cents, format) => {
        const value = Number(cents || 0) / 100;
        const fmt = (n, dec, thou, sep) => {
            const [i, d] = n.toFixed(dec).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (dec ? sep + d : '');
        };
        return String(format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
            amount: fmt(value, 2, ',', '.'),
            amount_no_decimals: fmt(value, 0, ',', '.'),
            amount_with_comma_separator: fmt(value, 2, '.', ','),
            amount_no_decimals_with_comma_separator: fmt(value, 0, '.', ','),
            amount_with_apostrophe_separator: fmt(value, 2, "'", '.'),
            amount_with_space_separator: fmt(value, 2, ' ', ','),
        }[k] || fmt(value, 2, ',', '.')));
    };
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const bump = (el, cls) => { if (!el || reduce.matches) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };

    function init(root) {
        if (root.dataset.swReady) return;
        root.dataset.swReady = '1';
        const group = $('[data-sw-group]', root);
        const header = $('[data-sw-header]', root);
        const scrim = $('[data-scrim]', root);
        if (!group || !header || !scrim) return;
        const state = { mega: null, panel: null };
        const moneyFormat = root.dataset.moneyFormat;

        /* Keep the spacer equal to the header height (no layout shift) */
        const measure = () => root.style.setProperty('--sw-group-h', group.offsetHeight + 'px');
        measure();
        if ('ResizeObserver' in window) new ResizeObserver(measure).observe(group);

        /* ---------- Announcement bar ---------- */
        const ann = $('[data-sw-announce]', group);
        if (ann) {
            let dismissed = false;
            try { dismissed = sessionStorage.getItem('sw-announce-off') === '1'; } catch (e) { }
            if (dismissed && !window.Shopify?.designMode) { ann.remove(); measure(); }
            else {
                const track = $('.sw-announce__track', ann);
                const msgs = $$('.sw-announce__msg', ann);
                const speed = (parseInt(ann.dataset.autoplay, 10) || 0) * 1000;
                let idx = 0, timer = null;
                const sync = () => msgs.forEach((m, i) => { m.inert = i !== idx; m.setAttribute('aria-hidden', String(i !== idx)); });
                const show = (n) => {
                    const prev = msgs[idx];
                    idx = (n + msgs.length) % msgs.length;
                    if (prev === msgs[idx]) return;
                    prev.classList.remove('is-active'); prev.classList.add('is-leaving');
                    setTimeout(() => prev.classList.remove('is-leaving'), 650);
                    msgs[idx].classList.add('is-active');
                    sync();
                };
                const play = () => {
                    clearInterval(timer);
                    if (reduce.matches || msgs.length < 2 || !speed) return;
                    track.setAttribute('aria-live', 'off');
                    timer = setInterval(() => show(idx + 1), speed);
                };
                const stop = () => clearInterval(timer);
                sync();
                ann.addEventListener('mouseenter', stop); ann.addEventListener('mouseleave', play);
                ann.addEventListener('focusin', stop); ann.addEventListener('focusout', play);
                $$('[data-announce]', ann).forEach((b) => b.addEventListener('click', () => {
                    track.setAttribute('aria-live', 'polite');
                    show(idx + (b.dataset.announce === 'next' ? 1 : -1));
                }));
                const close = $('.sw-announce__close', ann);
                close && close.addEventListener('click', () => {
                    stop();
                    try { sessionStorage.setItem('sw-announce-off', '1'); } catch (e) { }
                    const done = () => { if (ann.isConnected) { ann.remove(); measure(); } };
                    ann.classList.add('is-closing');
                    ann.addEventListener('transitionend', done, { once: true });
                    setTimeout(done, 600);
                    const logo = $('.sw-logo', header); logo && logo.focus({ preventScroll: true });
                });
                document.addEventListener('shopify:block:select', (e) => {
                    const i = msgs.indexOf(e.target); if (i > -1) { stop(); show(i); }
                });
                play();
            }
        }

        /* ---------- Sticky: transparent at top, solid on scroll, hide down / show up ---------- */
        const transparent = group.dataset.transparent === 'true';
        const sticky = group.dataset.sticky || 'smart';
        let lastY = window.scrollY, ticking = false;
        const update = () => {
            const y = Math.max(0, window.scrollY);
            const atTop = y <= 10;
            group.classList.toggle('is-scrolled', !atTop);
            group.classList.toggle('is-transparent', transparent && atTop && !state.mega);
            if (sticky === 'smart' && !state.mega && !state.panel) {
                const h = group.offsetHeight;
                if (y > h + 80 && y > lastY + 6) group.classList.add('is-hidden');
                else if (y < lastY - 6 || y <= h) group.classList.remove('is-hidden');
            }
            if (Math.abs(y - lastY) > 6 || atTop) lastY = y;
            ticking = false;
        };
        window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
        group.addEventListener('focusin', () => group.classList.remove('is-hidden'));
        update();

        /* ---------- Mega menu ---------- */
        const megaBtns = $$('[data-mega]', header);
        let openT = 0, closeT = 0, openedAt = 0;
        const panelOf = (btn) => document.getElementById(btn.getAttribute('aria-controls'));
        const setMega = (btn, on) => { btn.setAttribute('aria-expanded', String(on)); const p = panelOf(btn); p && p.classList.toggle('is-open', on); };
        const openMega = (btn) => {
            clearTimeout(closeT);
            if (state.mega === btn) return;
            header.classList.toggle('is-switching', !!state.mega);
            if (state.mega) setMega(state.mega, false);
            setMega(btn, true);
            state.mega = btn; openedAt = performance.now();
            scrim.classList.add('is-on');
            group.classList.remove('is-hidden');
            update();
        };
        const closeMega = (focusBack) => {
            clearTimeout(openT); clearTimeout(closeT);
            const btn = state.mega; if (!btn) return;
            setMega(btn, false);
            state.mega = null;
            setTimeout(() => header.classList.remove('is-switching'), 300);
            if (!state.panel) scrim.classList.remove('is-on');
            update();
            if (focusBack) btn.focus();
        };
        megaBtns.forEach((btn) => {
            const li = btn.closest('li');
            li.addEventListener('pointerenter', (e) => {
                if (e.pointerType !== 'mouse') return;
                clearTimeout(openT); clearTimeout(closeT);
                openT = setTimeout(() => openMega(btn), state.mega ? 0 : 90);
            });
            li.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') clearTimeout(openT); });
            btn.addEventListener('click', () => {
                if (state.mega === btn) { if (performance.now() - openedAt > 450) closeMega(); }
                else openMega(btn);
            });
            btn.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowDown') {
                    e.preventDefault(); openMega(btn);
                    const first = panelOf(btn).querySelector('a'); first && setTimeout(() => first.focus(), 30);
                }
            });
        });
        $$('.sw-nav__list > li:not(.has-mega)', header).forEach((li) => li.addEventListener('pointerenter', (e) => {
            if (e.pointerType !== 'mouse' || !state.mega) return;
            clearTimeout(openT); closeT = setTimeout(() => closeMega(), 120);
        }));
        header.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && state.mega) closeT = setTimeout(() => closeMega(), 180); });
        header.addEventListener('pointerenter', () => clearTimeout(closeT));
        header.addEventListener('focusout', (e) => { if (state.mega && !header.contains(e.relatedTarget)) closeMega(); });
        desktop.addEventListener && desktop.addEventListener('change', () => { closeMega(); if (state.panel && state.panel.dataset.panel === 'menu' && desktop.matches) closePanel(); });

        /* ---------- Overlays: search, cart drawer, mobile menu ---------- */
        const outside = () => [group, $('main') || $('#MainContent'), $('footer'), ...$$('.shopify-section-group-footer-group')].filter((n) => n && !root.contains(n) || n === group);
        let lastFocus = null, scrimT = 0;
        const focusables = (el) => $$('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter((n) => n.offsetParent !== null || n === document.activeElement);
        function openPanel(name, trigger) {
            const el = $('[data-panel="' + name + '"]', root);
            if (!el) return false;
            closeMega();
            if (state.panel && state.panel !== el) closePanel(false);
            clearTimeout(scrimT);
            lastFocus = trigger || document.activeElement;
            state.panel = el;
            el.classList.add('is-open');
            scrim.classList.add('is-on', 'is-top');
            html.style.setProperty('--sw-sbw', Math.max(0, window.innerWidth - html.clientWidth) + 'px');
            html.classList.add('sw-lock');
            $$('img[loading="lazy"]', el).forEach((i) => (i.loading = 'eager'));
            outside().forEach((n) => (n.inert = true));
            $$('[aria-controls="' + el.id + '"]', root).forEach((b) => b.setAttribute('aria-expanded', 'true'));
            const target = name === 'search' ? $('[data-search-input]', el) : $('[data-close]', el);
            setTimeout(() => target && target.focus({ preventScroll: true }), reduce.matches ? 0 : 60);
            return true;
        }
        function closePanel(restore = true) {
            const el = state.panel; if (!el) return;
            el.classList.remove('is-open');
            state.panel = null;
            outside().forEach((n) => (n.inert = false));
            html.classList.remove('sw-lock');
            scrim.classList.remove('is-on');
            scrimT = setTimeout(() => scrim.classList.remove('is-top'), 450);
            $$('[aria-controls="' + el.id + '"]', root).forEach((b) => b.setAttribute('aria-expanded', 'false'));
            if (restore && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
        }
        $$('[data-open]', root).forEach((b) => b.addEventListener('click', (e) => { if (openPanel(b.dataset.open, b)) e.preventDefault(); }));
        $$('[data-panel] [data-close]', root).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); closePanel(); }));
        scrim.addEventListener('click', () => { if (state.panel) closePanel(); else closeMega(); });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (state.panel) { e.preventDefault(); closePanel(); }
                else if (state.mega) { e.preventDefault(); closeMega(true); }
            } else if (e.key === 'Tab' && state.panel) {
                const f = focusables(state.panel); if (!f.length) return;
                const first = f[0], last = f[f.length - 1];
                if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
                else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
            }
        });

        /* ---------- Mobile menu accordion ---------- */
        const toggles = $$('.sw-menu__toggle', root);
        toggles.forEach((t) => t.addEventListener('click', () => {
            const open = t.getAttribute('aria-expanded') !== 'true';
            toggles.forEach((o) => { if (o !== t) { o.setAttribute('aria-expanded', 'false'); document.getElementById(o.getAttribute('aria-controls')).classList.remove('is-open'); } });
            t.setAttribute('aria-expanded', String(open));
            document.getElementById(t.getAttribute('aria-controls')).classList.toggle('is-open', open);
        }));

        /* ---------- Predictive search ---------- */
        const input = $('[data-search-input]', root);
        if (input) {
            const grid = $('[data-results]', root);
            const label = $('[data-results-label]', root);
            const empty = $('[data-empty]', root);
            const defaultHTML = grid.innerHTML;
            const url = root.dataset.predictiveUrl;
            let t = 0, ctrl = null;
            const render = (q, products) => {
                label.textContent = 'Products for \u201C' + q + '\u201D';
                grid.innerHTML = products.map((p) => {
                    const img = (p.featured_image && p.featured_image.url) || p.image;
                    const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=600' : '';
                    const price = Math.round(parseFloat(p.price) * 100);
                    return '<li class="sw-search__card"><a href="' + esc(p.url) + '"><span class="sw-search__img">' +
                        (src ? '<img src="' + esc(src) + '" alt="' + esc((p.featured_image && p.featured_image.alt) || p.title) + '" width="600" height="800" loading="lazy">' : '') +
                        '</span><span class="sw-search__pname">' + esc(p.title) + '</span><span class="sw-search__price">' + esc(formatMoney(price, moneyFormat)) + '</span></a></li>';
                }).join('');
                empty.hidden = products.length > 0;
            };
            const search = () => {
                const q = input.value.trim();
                if (ctrl) ctrl.abort();
                if (!q) { grid.innerHTML = defaultHTML; label.textContent = label.dataset.defaultLabel; empty.hidden = true; return; }
                if (!url) return;
                ctrl = new AbortController();
                fetch(url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { signal: ctrl.signal })
                    .then((r) => r.json())
                    .then((data) => render(q, (data.resources && data.resources.results && data.resources.results.products) || []))
                    .catch(() => { });
            };
            input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(search, 220); });
            $$('[data-chip]', root).forEach((c) => c.addEventListener('click', () => { input.value = c.dataset.chip; search(); input.focus(); }));
        }

        /* ---------- Cart drawer (Shopify AJAX Cart API) ---------- */
        const drawer = $('[data-panel="cart"]', root);
        const lines = $('[data-lines]', root);
        const live = $('[data-cart-live]', root);
        const threshold = (parseFloat(root.dataset.freeShipping) || 0) * 100 * (parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
        const ICON_MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>';
        const ICON_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';
        const lineHTML = (item) => {
            const img = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=240' : '';
            const variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
            return '<li class="sw-line" data-key="' + esc(item.key) + '">' +
                '<a class="sw-line__img" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" width="240" height="320" loading="lazy">' : '') + '</a>' +
                '<div><div class="sw-line__top"><div><p class="sw-line__name"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
                (variant ? '<p class="sw-line__var">' + esc(variant) + '</p>' : '') + '</div>' +
                '<span class="sw-line__price">' + esc(formatMoney(item.final_line_price, moneyFormat)) + '</span></div>' +
                '<div class="sw-line__row"><div class="sw-qty" role="group" aria-label="Quantity">' +
                '<button type="button" data-qty-change="-1" aria-label="Decrease quantity of ' + esc(item.product_title) + '"' + (item.quantity <= 1 ? ' disabled' : '') + '>' + ICON_MINUS + '</button>' +
                '<output>' + item.quantity + '</output>' +
                '<button type="button" data-qty-change="1" aria-label="Increase quantity of ' + esc(item.product_title) + '">' + ICON_PLUS + '</button></div>' +
                '<button class="sw-line__remove" type="button" data-remove>Remove<span class="sw-sr"> ' + esc(item.product_title) + '</span></button></div></div></li>';
        };
        const setCount = (count) => {
            $$('[data-cart-count]', root).forEach((b) => { if (b.textContent !== String(count)) bump(b, 'is-pop'); b.textContent = count; b.hidden = count === 0; });
            $$('.sw-cart-btn', root).forEach((b) => b.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items')));
        };
        const renderCart = (cart, focusKey, focusSel, announce) => {
            setCount(cart.item_count);
            if (!drawer) return;
            const hc = $('[data-cart-heading-count]', drawer); if (hc) hc.textContent = '(' + cart.item_count + ')';
            const st = $('[data-subtotal]', drawer); if (st) st.textContent = formatMoney(cart.total_price, moneyFormat);
            const ship = $('[data-ship]', drawer);
            if (ship && threshold > 0) {
                const rem = threshold - cart.total_price;
                const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
                ship.classList.toggle('is-done', rem <= 0);
                $('[data-ship-text]', ship).innerHTML = rem > 0 ? 'You\u2019re <strong>' + esc(formatMoney(rem, moneyFormat)) + '</strong> away from free shipping' : 'You\u2019ve unlocked <strong>free shipping</strong>';
                const bar = $('.sw-ship__bar', ship); bar.style.setProperty('--p', pct + '%'); bar.setAttribute('aria-valuenow', String(pct));
                ship.hidden = cart.item_count === 0;
            }
            lines.innerHTML = cart.items.map(lineHTML).join('');
            lines.hidden = cart.item_count === 0;
            $('[data-cart-empty]', drawer).hidden = cart.item_count > 0;
            $('[data-cart-foot]', drawer).hidden = cart.item_count === 0;
            if (focusKey !== undefined) {
                const li = focusKey && lines.querySelector('[data-key="' + CSS.escape(focusKey) + '"]');
                const target = (li && focusSel && (li.querySelector(focusSel + ':not([disabled])') || li.querySelector('[data-remove]'))) || lines.querySelector('[data-remove]') || $('[data-close]', drawer);
                target && target.focus({ preventScroll: true });
            }
            if (announce && live) live.textContent = announce;
        };
        const cartUrl = root.dataset.cartUrl || '/cart';
        const changeUrl = root.dataset.cartChangeUrl || '/cart/change';
        const refreshCart = (open) => fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json()).then((cart) => { renderCart(cart); if (open && drawer && root.dataset.cartType === 'drawer') { bump($('.sw-cart-btn', root), 'is-bump'); openPanel('cart', $('.sw-cart-btn', root)); } return cart; })
            .catch(() => { });
        if (lines) {
            lines.addEventListener('click', (e) => {
                const btn = e.target.closest('button'); if (!btn) return;
                const li = btn.closest('[data-key]'); if (!li) return;
                const key = li.dataset.key;
                const current = parseInt($('output', li).textContent, 10) || 0;
                let qty;
                if (btn.matches('[data-remove]')) qty = 0;
                else if (btn.dataset.qtyChange) qty = Math.max(0, current + parseInt(btn.dataset.qtyChange, 10));
                else return;
                const sel = btn.matches('[data-remove]') ? null : '[data-qty-change="' + btn.dataset.qtyChange + '"]';
                li.classList.add(qty === 0 ? 'is-removing' : 'is-busy');
                fetch(changeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
                    .then((r) => r.json())
                    .then((cart) => {
                        if (cart.status) throw new Error(cart.description || cart.message);
                        const name = $('.sw-line__name', li).textContent;
                        renderCart(cart, qty === 0 ? null : key, sel, (qty === 0 ? name + ' removed. ' : name + ' quantity ' + qty + '. ') + 'Subtotal ' + formatMoney(cart.total_price, moneyFormat) + '.');
                    })
                    .catch((err) => { li.classList.remove('is-busy', 'is-removing'); if (live) live.textContent = (err && err.message) || 'Could not update your bag.'; });
            });
        }

        /* Keep the count live when anything else on the page changes the cart */
        if (!window.SwFetchPatched && window.fetch) {
            window.SwFetchPatched = true;
            const nativeFetch = window.fetch.bind(window);
            window.fetch = (...args) => {
                const p = nativeFetch(...args);
                try {
                    const u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
                    const method = ((args[1] && args[1].method) || (args[0] && args[0].method) || 'GET').toUpperCase();
                    if (method !== 'GET' && /\/cart\/(add|change|update|clear)/.test(u) && !(args[1] && args[1].swInternal)) {
                        p.then((r) => { if (r.ok) document.dispatchEvent(new CustomEvent('sw:cart-changed', { detail: { url: u } })); }).catch(() => { });
                    }
                } catch (e) { }
                return p;
            };
        }
        document.addEventListener('sw:cart-changed', (e) => {
            const add = /\/cart\/add/.test(e.detail.url);
            if (state.panel === drawer && !add) return; /* our own drawer already re-rendered */
            refreshCart(false);
        });
        window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(false); });

        /* Public API: SwHeader.openCart() / refreshCart(open) / openSearch() / openMenu() */
        window.SwHeader = {
            openCart: () => refreshCart(true),
            refreshCart: (open) => refreshCart(!!open),
            openSearch: () => openPanel('search'),
            openMenu: () => openPanel('menu'),
            close: () => closePanel(),
        };

        /* Theme editor: open panels when their settings are selected */
        document.addEventListener('shopify:section:unload', (e) => { if (e.target.contains(root)) { closePanel(false); closeMega(); } });
    }

    /* Bridge for Dawn-style product forms: they look for <cart-notification> and call these three methods.
       Ours re-reads the cart and opens this header's drawer after "Add to cart". */
    if (!customElements.get('cart-notification')) {
        customElements.define('cart-notification', class extends HTMLElement {
            getSectionsToRender() { return []; }
            setActiveElement(el) { this.activeElement = el; }
            renderContents() { window.SwHeader && window.SwHeader.openCart(); }
            open() { window.SwHeader && window.SwHeader.openCart(); }
        });
    }

    const boot = () => $$('.sw-root').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
})();
